/**
 * SCOPE ENFORCEMENT IS OFF — the one alert on this screen that is about a
 * SECURITY CONTROL rather than about data.
 *
 * `scope.note` is non-empty only when the reader has to see it: enforcement is
 * off for the organisation AND the reader is not an owner (an owner is org-wide
 * by design, so the flag says nothing about their own figures). When it is set,
 * a property manager assigned to three buildings is actually reading all twelve.
 *
 * A scoped-looking dashboard over unscoped data is a false statement about a
 * security control, and the person reading it will act on it.
 *
 * ── ONCE, AT THE PAGE LEVEL ──
 *
 * The server appends the same sentence to every hub response, so rendering it
 * per panel put it on screen five times in one scroll. `hubNotes` drops it from
 * the panels; this is the single loud placement it is dropped in favour of.
 */
import React from 'react';
import { AnalyticsScope } from '../../../../../api/analytics-client';
import {
  Warning,
  WarningBody,
  WarningIcon,
  WarningText,
  WarningTitle,
} from '../dashboard-screen.styled';

export const ScopeWarning: React.FC<{ scope?: AnalyticsScope }> = ({ scope }) => {
  if (!scope?.note) return null;

  return (
    <Warning role="alert" data-testid="scope-warning">
      <WarningIcon aria-hidden="true">!</WarningIcon>
      <WarningBody>
        {/* "Scope enforcement" is this codebase's word for a row-level
            security setting. The person reading this banner is a property
            manager being told, in effect, that the numbers on screen are not
            limited to their own buildings — which is what they need to know and
            what the old title did not say. */}
        <WarningTitle>
          These figures cover the whole organisation, not just your buildings
        </WarningTitle>
        <WarningText>{scope.note}</WarningText>
      </WarningBody>
    </Warning>
  );
};
